'use client'

import { useTranslations } from 'next-intl'
import { motion } from 'framer-motion'
import { Code, Zap, Brain, Shield } from 'lucide-react'

export default function ServicesSection() {
  const t = useTranslations('services')

  const services = [
    { key: 'dev', icon: <Code className="w-8 h-8" />, color: 'primary' },
    { key: 'automation', icon: <Zap className="w-8 h-8" />, color: 'secondary' },
    { key: 'solutions', icon: <Brain className="w-8 h-8" />, color: 'primary' },
    { key: 'privacy', icon: <Shield className="w-8 h-8" />, color: 'secondary' },
  ]

  return (
    <section className="section-padding bg-secondary-50 dark:bg-secondary-800">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-secondary-900 dark:text-white">
            {t('sectionTitle')}
          </h2>
          <p className="text-base sm:text-lg text-secondary-600 dark:text-secondary-300 max-w-3xl mx-auto">
            {t('sectionSubtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.key}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="bg-white dark:bg-secondary-900 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6"
            >
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto ${
                service.color === 'primary'
                  ? 'bg-primary-100 dark:bg-primary-900'
                  : 'bg-secondary-100 dark:bg-secondary-900'
              }`}>
                <div className={
                  service.color === 'primary'
                    ? 'text-primary-600 dark:text-primary-400'
                    : 'text-secondary-600 dark:text-secondary-400'
                }>
                  {service.icon}
                </div>
              </div>
              <h3 className="text-center font-bold text-secondary-900 dark:text-white mb-2">
                {t(`${service.key}.title`)}
              </h3>
              <p className="text-center text-sm text-secondary-600 dark:text-secondary-400">
                {t(`${service.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
